import Promise from 'promise-polyfill';
import { saveAs } from 'file-saver';
import Cookies from 'js-cookie';
require('isomorphic-fetch');

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

export const authHeader = (headers) => {
  let token = Cookies.get('SAVANNAH_TOKEN');
  if (token) {
    return { ...headers, Authorization: 'Bearer ' + token };
  } else {
    return headers;
  }
};

export const getBaseRequestConfig = () => {
  const config = {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
    headers: authHeader({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
  };

  return config;
};

export const postBaseRequestConfig = (body, overriddenOptions = {}) => {
  const config = {
    method: 'POST',
    credentials: 'include',
    headers: authHeader({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(body),
  };

  return Object.assign(config, overriddenOptions);
};

export const postFormRequestConfig = (bodyObj, overriddenOptions = {}) => {
  // TODO: Extract to api-utils.js
  const body = Object.entries(bodyObj)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&');

  const config = {
    method: 'POST',
    credentials: 'include',
    headers: authHeader({
      'Content-Type': 'application/x-www-form-urlencoded',
    }),
    body,
  };

  return Object.assign(config, overriddenOptions);
};

export const deleteBaseRequestConfig = (body) => {
  const config = {
    method: 'DELETE',
    mode: 'cors',
    credentials: 'include',
    headers: authHeader({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(body),
  };

  return config;
};

export const putBaseRequestConfig = (body ) => {
  const config = {
    method: 'PUT',
    mode: 'cors',
    credentials: 'include',
    headers: authHeader({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(body),
  };

  return config;
};

export const dlaAPIRequest = (model, action, params, config = {}) => {
  let body = {
    model: model,
    actionparam: action,
    params: params,
    config: config,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/api/rest/index`,
    postBaseRequestConfig(body)
  ).then((response) => {
    switch (config.responseType) {
      case 'blob':
        return response.blob();
      case 'json':
      default:
        return response.json();
    }
  });
};

/**
 * Helper function for when you expect a file attachment from the
 * response of a post (i.e. Excel export).
 *
 * The only ways to download file responses with fetch are very hacky.
 * We need to be able to leverage promises to manage loading states, though,
 * so we leverage the file-saver package to encapsulate the hackiness.
 *
 * @param {string} url - API URL you want to post to
 * @param {FormData} body - FormData to include in the POST body
 * @return {Promise} - fetch Promise
 */
export const postFormExpectingDownload = (url, formData, filename = '') => {
  const config = {
    method: 'POST',
    credentials: 'include',
    body: formData,
  };

  let saveFilename = filename;
  return fetch(url, config)
    .then((response) => {
      // Try to extract the filename if one wasn't provided
      if (!filename) saveFilename = extractFilenameFromHeader(response);

      return response.blob();
    })
    .then((blob) => saveAs(blob, saveFilename));
};

function extractFilenameFromHeader(response) {
  const contentDisposition = response.headers.get('content-disposition'); // header name is case-insensitive
  if (contentDisposition) {
    const regex = /^attachment;.*filename=["']*([\w-.&]+)["']*/;
    const filenameResult = regex.exec(contentDisposition)[1];
    if (filenameResult) return filenameResult;
  }

  return null;
}
